import platform from '@play-co/gcinstant';
import { createPersistentEmitter } from 'src/lib/Emitter';
import { System } from 'src/lib/utils';
import StateObserver from 'src/StateObserver';
import { levelActions } from './level.redux';

export function levelSystem(): System {
  const handleLevelUpdated = (payload) => {
    StateObserver.dispatch(
      levelActions.setLevel({ id: platform.playerID, payload }),
    );
  };

  const levelEmitter = createPersistentEmitter(({ user: { level } }) => level);

  return {
    start: () => {
      levelEmitter.addListener(handleLevelUpdated);
    },
    stop: () => {
      levelEmitter.removeListener(handleLevelUpdated);
    },
  };
}
